<div class="row" id="divProperties">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="border-div no-shadow" style="margin-bottom:0 !important;">
      <div class="row"  *ngIf=" portfoliosummary.TotalProperties!=null">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="be-market-hlts-wrapper be-portfolio-smry">
            <div class="row">
              <div class="col-sm-8">
                <h5 class="bluelabel myPortfolioNormalHeading">My Portfolio Summary</h5>
              </div>
            </div>
            <div class="margin-top-10 d-flex be-market-hlts">
              <div class="be-market-data d-flex">
                <div class="d-flex flex-direction-colum flex-1">
                  <p class="label margin-bottom-5"># Properties</p>
                  <div class="d-flex in-box-t">
                    <p class="margin-left-10 m-data">{{portfoliosummary.TotalProperties!=null?portfoliosummary.TotalProperties:'-'}}</p>
                  </div>
                </div>
              </div>
              <div class="be-market-data d-flex">
                <div class="d-flex flex-direction-colum flex-1">
                  <p class="label margin-bottom-5">Portfolio Rent</p>
                  <div class="d-flex in-box-t">
                    <p class="margin-left-10 m-data">{{portfoliosummary.PortfolioRent!=null? '$ ' + (portfoliosummary.PortfolioRent|number):'-'}}</p>
                  </div>
                </div>
              </div>
              <div class="be-market-data d-flex">
                <div class="d-flex flex-direction-colum flex-1">
                  <p class="label margin-bottom-5">WALT</p>
                  <div class="d-flex in-box-t">
                    <p class="margin-left-10 m-data">{{portfoliosummary.WALT!=null?portfoliosummary.WALT + ' Years':'-'}}</p>
                  </div>
                </div>
              </div>
              <div class="be-market-data last d-flex">
                <div class="d-flex flex-direction-colum flex-1">
                  <p class="label margin-bottom-5">Total SF</p>
                  <div class="d-flex in-box-t">
                    <p class="margin-left-10 m-data">{{portfoliosummary.TotalSF!=null?(portfoliosummary.TotalSF|number):'-'}}</p>
                  </div>
                </div>
              </div>
              <div class="leftside clearfix">
                <div class="d-flex flex-direction-colum flex-1">
                  <button class="right-btn btn btn-addgreen btn-lg margin-bottom-10" placement="left" (click)="openAddNewProperty()"> + Add Property</button>
                </div>
                <div class="d-flex flex-direction-colum flex-1">
                  <button class="right-btn btn btn-success btn-lg margin-bottom-5 " id="btnExcel" placement="left" (click)="RequestBov('',RequestBovModal,'portfolio-bov-modal');"> Request BOV</button>
                </div>
                <div class="d-flex flex-direction-colum flex-1">
                  <button class="right-btn btn btn-addyellow btn-lg margin-bottom-5 margin-top-10 " id="btnExcel" placement="left" (click)="callAnalyzeParent();"> ANALYZE PORTFOLIO</button>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
<ng-template #RequestBovModal>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Would you like to request a BOV?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefBov.hide();modelClose();">
      <span aria-hidden="true">X</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group" *ngIf="requestedProperties?.length==0">
      <!--<h6 class="displayvalue requestBovTitle">Would you like to request a BOV?</h6>-->
      <h6 class="info-text  margin-top-15 margin-bottom-30">Please add a property to request a BOV or talk to a broker.</h6>
    </div>
    <div class="row" *ngIf="requestedProperties!=null && requestedProperties?.length>0">
      <ul *ngFor="let myList of requestedProperties;let j = index ">
        <li class="transition" *ngIf="j==0">
          <label class="custom-checkbox withoutlabel margin-bottom-10">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">Select All</span>
          </label>
        </li>
        <li class="transition">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="myList.IsChecked" (change)="onCheckboxChange($event.target.checked,myList.Guid);" class="ng-pristine ng-valid ng-touched"><i></i> <span class="requestBovTenant">{{myList.TenantName}}</span>{{' - '+ myList.Address }}
          </label>
        </li>
      </ul>
    </div>
    <div class="text-right">
      <button type="button" *ngIf="(requestedProperties?.length==0&&(portfoliosummary==null||portfoliosummary.TotalProperties==0||portfoliosummary.TotalProperties==null)&&(this.authentication.Principal()||this.authentication.Principal1031()||this.authentication.Seller()))" (click)="contactBroker();modelClose();" class="btn btn-small no-border btn-default btn-lg">Contact Broker</button>
      <button class="btn btn-success btn-lg" *ngIf="requestedProperties?.length==0" (click)="openAddNewProperty();modalRefBov.hide();modelClose();"> + Add Property</button>
      <button class="btn btn-success btn-lg" *ngIf="requestedProperties!=null && requestedProperties?.length>0" (click)="SubmitBovRequest();">Request BOV</button>
    </div>
  </div>

</ng-template>
